import { reviews } from "@/mocks/home";

export default function Review() {
  return (
    <section id="review" className="relative w-full bg-background-900/60 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="text-sm tracking-widest text-accent-400">LATEST REVIEWS</span>
            <h2 className="mt-2 font-heading text-3xl text-foreground-50 md:text-4xl">最新评测</h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-400">
              深度观感、追番指南与作品解析，用真实文字陪你理解每一部作品的用心之处。
            </p>
          </div>
          <span className="text-xs text-foreground-500">持续更新中</span>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4 md:gap-6">
          {reviews.map((rv) => (
            <article
              key={rv.id}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-800/70 bg-background-900 transition-colors hover:border-accent-500/60"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={rv.image}
                  alt={rv.title}
                  title={rv.title}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <span className="absolute left-2 top-2 rounded bg-accent-500 px-2 py-0.5 text-[11px] text-background-50">
                  {rv.category}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4">
                <div className="flex items-center gap-3 text-[11px] text-foreground-500">
                  <span className="flex items-center gap-1"><i className="ri-calendar-line" />{rv.date}</span>
                  <span className="flex items-center gap-1"><i className="ri-time-line" />{rv.readTime}</span>
                </div>
                <h3 className="mt-2 text-sm font-medium leading-snug text-foreground-100 transition-colors group-hover:text-accent-300">
                  {rv.title}
                </h3>
                <p className="mt-2 line-clamp-3 text-xs leading-relaxed text-foreground-400">{rv.excerpt}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}